import './styles/tabs.scss';